<button mat-button (click)="data.signin()" *ngIf="!data.profile">
    Увійти
</button>

<button mat-button class="profile-button" *ngIf="data.profile" (click)="onShowProfile()">
    <img [src]="data.profile.user_image_url || '/assets/logo.png'" />
    <span>{{data.profile.user_name.split(' ')[0]}}</span>
</button>
